import React from "react";
import LiveClassCard, { LiveClassProps } from "./LiveClassCard";

export default function LiveClassesContainer({
  classes,
}: {
  classes: LiveClassProps[];
}) {
  if (!classes || classes.length === 0) {
    return (
      <div className="p-4 text-center text-gray-400">
        No upcoming live classes were found.
      </div>
    );
  }

  // Add this function to determine the appropriate header text based on classes statuses
  const getHeaderText = (classes) => {
    if (!classes || classes.length === 0) {
      return "Live Classes";
    }

    // Count classes by status
    const statuses = classes.reduce((acc, cls) => {
      const status = cls.status || "initial";
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {});

    const hasLive = statuses["live"] > 0;
    const hasUpcoming = statuses["initial"] > 0;
    const hasPast = statuses["disposed"] > 0;
    const totalTypes =
      (hasLive ? 1 : 0) + (hasUpcoming ? 1 : 0) + (hasPast ? 1 : 0);

    // Determine header based on combinations
    if (totalTypes > 1) {
      return "Live Classes Schedule";
    } else if (hasLive) {
      return "Live Classes Now";
    } else if (hasUpcoming) {
      return "Upcoming Live Classes";
    } else if (hasPast) {
      return "Past Live Classes";
    }

    return "Live Classes";
  };

  return (
    <div className="live-classes-container">
      <h3 className="text-base font-semibold mb-3 text-gray-200">
        {getHeaderText(classes)}
      </h3>

      <div className="grid-container">
        {classes.map((classData) => (
          <div key={classData.id} className="card-wrapper">
            <LiveClassCard classData={classData} />
          </div>
        ))}
      </div>

      <style jsx>{`
        .live-classes-container {
          margin: 0.75rem 0 1rem;
          width: 100%;
        }

        .grid-container {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
          margin-bottom: 8px;
        }

        .card-wrapper {
          min-width: 0; /* Ensures cards can shrink if needed */
        }

        /* Responsive adjustments */
        @media (max-width: 540px) {
          .grid-container {
            grid-template-columns: 1fr; /* Single column on very small screens */
          }
        }

        @media (min-width: 541px) and (max-width: 768px) {
          .grid-container {
            gap: 12px;
          }
        }

        @media (min-width: 768px) {
          .grid-container {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (min-width: 1200px) {
          .grid-container {
            max-width: 650px; /* Slightly wider to ensure time doesn't truncate */
          }
        }
      `}</style>
    </div>
  );
}
